/*
 * When pasting headings from v1 into v2, the HTML contains,
 * among other things, an aha-tooltip element. This serializer
 * strips it away so that the content is pasted correctly.
 *
 * See ACT-1477
 */
import Serializer, { type DeserializeArguments } from './Serializer';
import { isHTMLElementNode } from '../helpers/serializerHelpers';

class SerializerAhaTooltip extends Serializer {
  static deserialize({ el }: DeserializeArguments) {
    if (!isHTMLElementNode(el) || el.tagName.toLowerCase() !== 'aha-tooltip')
      return;
    return {
      text: '',
    };
  }
}
export default SerializerAhaTooltip;
